'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherCheck } from '@subframe/core';
import { Badge, Button, Checkbox } from '@/shared/components/ui';
import { PLANO_TIER_PRECOS_MENSAIS } from '../constants';
import type { UseNegociacaoSelfReturn } from '../hooks';
import type { PlanoTier } from '../types';
import { WizardProgressHeader } from './WizardProgressHeader';
interface PagamentoScreenProps {
  vm: UseNegociacaoSelfReturn;
}
interface PlanoColunaProps {
  tier: PlanoTier;
  preco: string;
  cobrancaLabel: string;
  recursos: string[];
  selecionado: boolean;
  recomendado?: boolean;
  onSelecionar: () => void;
  onSeguir: () => void;
  seguirDisabled: boolean;
  selecaoBloqueada: boolean;
}
const PlanoColuna = t0 => {
  const $ = _c(29);
  const {
    preco,
    cobrancaLabel,
    recursos,
    selecionado,
    recomendado: t1,
    onSelecionar,
    onSeguir,
    seguirDisabled,
    selecaoBloqueada
  } = t0;
  const recomendado = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== onSelecionar || $[1] !== selecaoBloqueada) {
    t2 = () => {
      if (selecaoBloqueada) {
        return;
      }
      onSelecionar();
    };
    $[0] = onSelecionar;
    $[1] = selecaoBloqueada;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `flex w-full max-w-[440px] flex-1 basis-[320px] flex-col rounded-[16px] border-2 border-solid p-6 text-left transition-all sm:basis-[380px] sm:p-8 ${selecaoBloqueada ? "cursor-not-allowed" : "cursor-pointer hover:shadow-md"} ${selecionado ? "border-brand-600" : "border-neutral-200"} ${recomendado ? "bg-brand-50" : "bg-white"}`;
  let t4;
  if ($[3] !== recomendado) {
    t4 = recomendado ? <div className="flex items-center gap-2"><Badge variant="brand">Mais popular</Badge><Badge variant="neutral">Recomendado</Badge></div> : <Badge variant="neutral" className="self-start">Starter</Badge>;
    $[3] = recomendado;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="text-label-muted text-[15px] font-medium">/mês</span>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== preco) {
    t6 = <div className="text-heading-dark mt-3 text-[28px] font-bold">{preco}{t5}</div>;
    $[6] = preco;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== cobrancaLabel) {
    t7 = <span className="text-[13px] text-neutral-500">{cobrancaLabel}</span>;
    $[8] = cobrancaLabel;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== recursos) {
    t8 = recursos.map(_temp);
    $[10] = recursos;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t8) {
    t9 = <div className="mt-5 flex flex-col gap-2">{t8}</div>;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const t10 = recomendado ? "brand-primary" : "neutral-secondary";
  let t11;
  if ($[14] !== onSeguir) {
    t11 = event => {
      event.stopPropagation();
      onSeguir();
    };
    $[14] = onSeguir;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== seguirDisabled || $[17] !== t10 || $[18] !== t11) {
    t12 = <Button size="small" className="mt-6 w-full" variant={t10} disabled={seguirDisabled} onClick={t11}>Seguir para o pagamento</Button>;
    $[16] = seguirDisabled;
    $[17] = t10;
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== selecaoBloqueada || $[21] !== t12 || $[22] !== t2 || $[23] !== t3 || $[24] !== t4 || $[25] !== t6 || $[26] !== t7 || $[27] !== t9) {
    t13 = <button type="button" aria-disabled={selecaoBloqueada} onClick={t2} className={t3}>{t4}{t6}{t7}{t9}{t12}</button>;
    $[20] = selecaoBloqueada;
    $[21] = t12;
    $[22] = t2;
    $[23] = t3;
    $[24] = t4;
    $[25] = t6;
    $[26] = t7;
    $[27] = t9;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  return t13;
};
export const PagamentoScreen = t0 => {
  const $ = _c(59);
  const {
    vm
  } = t0;
  const anual = vm.planoPeriodo === "anual";
  const cobrancaLabel = anual ? "Cobran\xE7a anual recorrente" : "Cobran\xE7a mensal recorrente";
  const setupIntermediario = anual ? "Taxa de setup: Isenta \u2014 Economize R$ 5.000" : "Taxa de setup: R$ 5.000";
  const togglePill = _temp2;
  let t1;
  if ($[0] !== vm.wizardSteps) {
    t1 = <WizardProgressHeader steps={vm.wizardSteps} />;
    $[0] = vm.wizardSteps;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="mb-8 flex w-full max-w-[1280px] flex-col items-center gap-2 text-center"><h1 className="text-heading-dark text-2xl font-semibold sm:text-[32px]">Qual plano faz mais sentido para você?</h1><p className="text-label-muted text-base">Compare os planos e escolha o melhor se encaixe no seu momento.</p></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = togglePill(anual);
  let t4;
  if ($[3] !== vm) {
    t4 = () => vm.definirPeriodo("anual");
    $[3] = vm;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = <button type="button" className={t3} onClick={t4}>Anual</button>;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = togglePill(!anual);
  let t7;
  if ($[8] !== vm) {
    t7 = () => vm.definirPeriodo("mensal");
    $[8] = vm;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t6 || $[11] !== t7) {
    t8 = <button type="button" className={t6} onClick={t7}>Mensal</button>;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t5 || $[14] !== t8) {
    t9 = <div className="mb-8 inline-flex rounded-full bg-neutral-100 p-1">{t5}{t8}</div>;
    $[13] = t5;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = ["Taxa de setup: Isenta", "At\xE9 100 envios por m\xEAs", "Atendimento padr\xE3o"];
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  const t11 = vm.planoTier === "starter";
  let t12;
  let t13;
  if ($[17] !== vm) {
    t12 = () => vm.definirTier("starter");
    t13 = () => vm.seguirPagamento("starter");
    $[17] = vm;
    $[18] = t12;
    $[19] = t13;
  } else {
    t12 = $[18];
    t13 = $[19];
  }
  const t14 = !vm.termosAceitos || vm.iniciandoPagamento;
  let t15;
  if ($[20] !== cobrancaLabel || $[21] !== t11 || $[22] !== t12 || $[23] !== t13 || $[24] !== t14 || $[25] !== vm.iniciandoPagamento) {
    t15 = <PlanoColuna tier="starter" preco={`R$ ${PLANO_TIER_PRECOS_MENSAIS.starter}`} cobrancaLabel={cobrancaLabel} recursos={t10} selecionado={t11} onSelecionar={t12} onSeguir={t13} seguirDisabled={t14} selecaoBloqueada={vm.iniciandoPagamento} />;
    $[20] = cobrancaLabel;
    $[21] = t11;
    $[22] = t12;
    $[23] = t13;
    $[24] = t14;
    $[25] = vm.iniciandoPagamento;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== setupIntermediario) {
    t16 = [setupIntermediario, "101 a 250 envios por m\xEAs", "Atendimento diferenciado"];
    $[27] = setupIntermediario;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  const t17 = vm.planoTier === "intermediario";
  let t18;
  let t19;
  if ($[29] !== vm) {
    t18 = () => vm.definirTier("intermediario");
    t19 = () => vm.seguirPagamento("intermediario");
    $[29] = vm;
    $[30] = t18;
    $[31] = t19;
  } else {
    t18 = $[30];
    t19 = $[31];
  }
  const t20 = !vm.termosAceitos || vm.iniciandoPagamento;
  let t21;
  if ($[32] !== cobrancaLabel || $[33] !== t16 || $[34] !== t17 || $[35] !== t18 || $[36] !== t19 || $[37] !== t20 || $[38] !== vm.iniciandoPagamento) {
    t21 = <PlanoColuna tier="intermediario" preco={`R$ ${PLANO_TIER_PRECOS_MENSAIS.intermediario}`} cobrancaLabel={cobrancaLabel} recursos={t16} selecionado={t17} recomendado={true} onSelecionar={t18} onSeguir={t19} seguirDisabled={t20} selecaoBloqueada={vm.iniciandoPagamento} />;
    $[32] = cobrancaLabel;
    $[33] = t16;
    $[34] = t17;
    $[35] = t18;
    $[36] = t19;
    $[37] = t20;
    $[38] = vm.iniciandoPagamento;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] !== t15 || $[41] !== t21) {
    t22 = <div className="flex w-full max-w-[1280px] flex-wrap justify-center gap-8">{t15}{t21}</div>;
    $[40] = t15;
    $[41] = t21;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <span className="bg-success-50 text-success-700 mt-8 rounded-full px-3.5 py-1.5 text-xs font-semibold">7 dias grátis em qualquer plano</span>;
    $[43] = t23;
  } else {
    t23 = $[43];
  }
  let t24;
  if ($[44] !== vm.alternarTermos || $[45] !== vm.termosAceitos) {
    t24 = <Checkbox checked={vm.termosAceitos} onCheckedChange={vm.alternarTermos} label={"Ao avan\xE7ar, confirmo que li e aceito os Termos de Uso e a Pol\xEDtica de Privacidade"} />;
    $[44] = vm.alternarTermos;
    $[45] = vm.termosAceitos;
    $[46] = t24;
  } else {
    t24 = $[46];
  }
  let t25;
  if ($[47] !== vm) {
    t25 = <button type="button" onClick={() => vm.goTo("terms")} className="text-brand-600 text-xs underline">Ler os termos</button>;
    $[47] = vm;
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  let t26;
  if ($[49] !== t24 || $[50] !== t25) {
    t26 = <div className="mt-6 flex flex-col items-center gap-1">{t24}{t25}</div>;
    $[49] = t24;
    $[50] = t25;
    $[51] = t26;
  } else {
    t26 = $[51];
  }
  let t27;
  if ($[52] !== t22 || $[53] !== t26 || $[54] !== t9) {
    t27 = <div className="flex flex-1 flex-col items-center px-6 py-10 md:px-20 md:py-16">{t2}{t9}{t22}{t23}{t26}</div>;
    $[52] = t22;
    $[53] = t26;
    $[54] = t9;
    $[55] = t27;
  } else {
    t27 = $[55];
  }
  let t28;
  if ($[56] !== t1 || $[57] !== t27) {
    t28 = <div className="flex min-h-screen w-full flex-col bg-white">{t1}{t27}</div>;
    $[56] = t1;
    $[57] = t27;
    $[58] = t28;
  } else {
    t28 = $[58];
  }
  return t28;
};
function _temp(recurso) {
  return <div key={recurso} className="flex items-center gap-2 text-[13px] text-neutral-700"><FeatherCheck className="text-success-700 h-3.5 w-3.5 flex-none" />{recurso}</div>;
}
function _temp2(ativo) {
  return `flex-1 rounded-full px-6 py-2 text-[13px] font-semibold transition-colors ${ativo ? "bg-brand-600 text-white" : "text-label-muted bg-transparent"}`;
}